import { ISetFieldsVisibility } from '../../../../actions/bookingCalendar/reservationModal/fieldVisibility'
import { IBookingCalendarStore } from '../../index'

export default function(
  state: IBookingCalendarStore,
  action: ISetFieldsVisibility,
): IBookingCalendarStore {
  return {
    ...state,
    reservationModal: {
      ...state.reservationModal,
      fieldVisibility: action.value,
    },
  }
}
